import { defineComponent as _defineComponent } from 'vue'
import { processPostBody } from '@@/vuecomposables/process_post_or_comment_body'
import emitClickOnTouch from '@@/vuedirectives/emit_click_on_touch'
import { onMounted, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfacePostBody',
  props: {
    content: null,
    darkMode: { type: [Boolean, String], default: 'auto' },
    isTextSelectable: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { content: string, darkMode: boolean | 'auto', isTextSelectable: boolean };



const vEmitClickOnTouch = emitClickOnTouch

const postBodyRef = ref<HTMLParagraphElement>()
const body = ref<string>(props.content)

const performPostUpdateActions = async (): Promise<void> => {
  if (postBodyRef.value == null) return
  body.value = await processPostBody(props.content, postBodyRef.value)
}

watch(() => props.content, performPostUpdateActions)

onMounted((): void => {
  performPostUpdateActions()
})

return { __sfc: true,props, vEmitClickOnTouch, postBodyRef, body, performPostUpdateActions }
}

})